import { useTranslation } from 'react-i18next'

interface ConceptSlot {
  position: number
  scene: string
  rationale: string
  emotion: string
  thumbnail_check: string
  scroll_stop_score: number
  anti_patterns: string[]
}

interface Props {
  slot: ConceptSlot
}

export function ImageConceptSlotCard({ slot }: Props) {
  const { t } = useTranslation()
  const scoreColor =
    slot.scroll_stop_score >= 75
      ? 'bg-green-500'
      : slot.scroll_stop_score >= 50
        ? 'bg-yellow-500'
        : 'bg-red-500'

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4 space-y-3 dark:border-neutral-700 dark:bg-neutral-800">
      <div className="flex items-center justify-between">
        <span className="text-sm font-semibold text-gray-500 dark:text-neutral-400">
          {t('imageConcept.position')} {slot.position}
        </span>
        <span className="text-xs text-gray-400 dark:text-neutral-500">{slot.emotion}</span>
      </div>
      <p className="text-sm text-gray-900 dark:text-neutral-100">{slot.scene}</p>
      <p className="text-xs text-gray-500 dark:text-neutral-400 italic">{slot.rationale}</p>
      <div className="space-y-1">
        <div className="flex items-center justify-between text-xs text-gray-500 dark:text-neutral-400">
          <span>{t('imageConcept.scrollStop')}</span>
          <span>{slot.scroll_stop_score}</span>
        </div>
        <div className="h-1.5 w-full rounded-full bg-gray-100 dark:bg-neutral-700">
          <div
            className={`h-1.5 rounded-full ${scoreColor}`}
            style={{ width: `${slot.scroll_stop_score}%` }}
          />
        </div>
      </div>
      {slot.thumbnail_check && (
        <p className="text-xs text-gray-400 dark:text-neutral-500">
          {t('imageConcept.thumbnailCheck')}: {slot.thumbnail_check}
        </p>
      )}
      {slot.anti_patterns.length > 0 && (
        <div className="text-xs text-red-500 dark:text-red-400">
          {slot.anti_patterns.map((ap, i) => (
            <span key={i} className="mr-2">
              {ap}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}
